import { render, staticRenderFns } from "./UniqueNumber.vue?vue&type=template&id=f84ab144"
import script from "./UniqueNumber.vue?vue&type=script&lang=js"
export * from "./UniqueNumber.vue?vue&type=script&lang=js"
import style0 from "./UniqueNumber.vue?vue&type=style&index=0&id=f84ab144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports